The identifier for the `AdvertisementBranding` applied to the posted job ad.

This is included for HR-JSON compatibility;
GraphQL users should use the `branding` nested object instead.
